module.exports = __webpack_public_path__ + "images/emails/h-tagline-9453934f.gif";